import { action } from '@play-co/replicant';
import createActions from 'src/replicant/config/actions/createActions';
import { BundleSaleProductId } from './match2-bundlesale.ruleset';
import { match2BundleSalePurchase } from './match2-bundlesale.modifiers';
import { match2BundleSaleIsFreeProduct } from './match2-bundlesale.getters';

export const match2BundleSaleActions = createActions({
  /**
   * Purchase a bundle sale product
   */
  match2BundleSalePurchase: action(
    (state, args: { product: BundleSaleProductId }, api) => {
      // Only allowed for free products.
      if (!match2BundleSaleIsFreeProduct(args.product)) return;

      match2BundleSalePurchase(state, args.product, api);
    },
  ),
});
